import { render, staticRenderFns } from "./StockDamageList.vue?vue&type=template&id=13dc66dc"
import script from "./StockDamageList.vue?vue&type=script&lang=js"
export * from "./StockDamageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports